export default __webpack_public_path__ + "static/mstile-310x150-3dd4e2d15c3d8b3f57f07106b049e28b.png";